export default {
  title: 'Interlocutores',
  contactsView: {
    deleteTitle: 'Listado de interlocutores para eliminar',
    success: 'Los interlocutores fueron eliminados con éxito.'
  },
  contact: {
    new: 'Nuevo interlocutor',
    data: 'Introduzca los datos del nuevo interlocutor',
    add: 'Incluir en agenda'
  },
  table: {
    saveNew: 'Guardar como nuevo elemento',
    createAndSelect: 'Crear y seleccionar',
    updateAndSelect: 'Actualizar y seleccionar',
    undo: 'Deshacer cambios',
    select: 'Seleccionar',
    noResults: 'No se encontraron resultados',
    document: 'NIF/CIF/NIE',
    reason: 'Razón Social/Nombre',
    nameSurname: 'Nombre Comercial/Apellidos',
    department: 'Destinatario',
    departmentCode: 'Departamento',
    managerbodyCode: 'Órgano gestor',
    managerbodyDescription: 'Descripción Org. Gestor',
    receiverCode: 'Código destinatario',
    costCenter: 'Centro de coste',
    documentAndName: 'NIF/CIF/NIE - Razón Social/Nombre',
    managerBodyInfo: 'Órgano gestor',
    processingUnitInfo: 'Unidad tramitadora',
    accountingOfficeInfo: 'Oficina contable'
  },
  searchContact: {
    title: 'Agenda',
    search: 'Buscar en la agenda',
    showing: 'Mostrando',
    document: 'NIF/CIF/NIE',
    reason: 'Razón Social/Nombre',
    nameSurname: 'Nombre Comercial/Apellidos',
    more: 'Ver más',
    addSelected: 'Añadir seleccionado',
    allContacts: 'Todos los contactos',
    bankiaContacts: 'Contactos de Bankia',
    deleteTitle: 'Eliminar interlocutores seleccionados',
    deleteConfirm: '¿Está seguro que desea eliminar los interlocutores seleccionados?',
    department: 'Destinatario',
    managerbodyCode: 'Órgano gestor',
    managerbodyDescription: 'Descripción Org. Gestor',
    receiverCode: 'Código destinatario'
  },
  button: {
    newElement: 'Nuevo elemento'
  }
}
